import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import logo from "../assets/logo.png";
import logo2 from "../assets/logo2.png";
import fixedWalletQr from "../assets/cryptopay.png";

class CryptoPay extends Component {
  state = {
    error: "",
    statusText: "Waiting for payment...",
    secondsLeft: 0,
    expired: false,
  };

  componentDidMount() {
    const order = this.getOrderData();
    console.log("CryptoPay mounted");
    console.log("CryptoPay order data:", order);

    if (!order || !order.orderId) {
      this.setState({ error: "Missing payment data." });
      return;
    }

    this.updateCountdown();
    this.countdownTimer = setInterval(this.updateCountdown, 1000);
    this.statusTimer = setInterval(this.checkOrderStatus, 5000);
    this.checkOrderStatus();
  }

  componentWillUnmount() {
    if (this.countdownTimer) clearInterval(this.countdownTimer);
    if (this.statusTimer) clearInterval(this.statusTimer);
  }

  getOrderData = () => {
    return this.props.location?.state || null;
  };

  updateCountdown = () => {
    const order = this.getOrderData();
    if (!order || !order.expiresAt) return;

    const diff = new Date(order.expiresAt).getTime() - Date.now();

    if (diff <= 0) {
      if (this.countdownTimer) clearInterval(this.countdownTimer);
      if (this.statusTimer) clearInterval(this.statusTimer);

      this.setState({
        secondsLeft: 0,
        expired: true,
        statusText: "Payment order expired.",
      });
      return;
    }

    this.setState({
      secondsLeft: Math.floor(diff / 1000),
    });
  };

  checkOrderStatus = async () => {
    const order = this.getOrderData();
    if (!order || !order.orderId) return;

    try {
      console.log("Checking order status for:", order.orderId);

      const res = await fetch(
        `api/crypto/order-status/${order.orderId}`
      );

      const data = await res.json();
      console.log("order-status response:", data);

      if (!res.ok || !data.ok) {
        throw new Error(data.message || "Failed to check payment");
      }

      if (data.order.status === "paid" || data.order.status === "claimed") {
        if (this.statusTimer) clearInterval(this.statusTimer);
        if (this.countdownTimer) clearInterval(this.countdownTimer);

        this.setState({
          statusText: "Payment received. Redirecting...",
        });

        setTimeout(() => {
          this.props.history.push("/logincredits300", {
            orderId: order.orderId,
            exactAmount: order.exactAmount,
            baseAmount: order.baseAmount,
            creditsToClaim: order.creditsToClaim,
            txHash: data.order.txHash || null,
          });
        }, 1000);

      } else if (data.order.status === "expired") {
        if (this.statusTimer) clearInterval(this.statusTimer);
        if (this.countdownTimer) clearInterval(this.countdownTimer);

        this.setState({
          expired: true,
          statusText: "Payment order expired.",
        });
      } else {
        this.setState({
          statusText: "Waiting for blockchain confirmation...",
        });
      }
    } catch (err) {
      console.error("checkOrderStatus error:", err);
      this.setState({
        error: err.message || "Unable to check payment status",
      });
    }
  };

  formatTime = (totalSeconds) => {
    const mins = Math.floor(totalSeconds / 60);
    const secs = totalSeconds % 60;
    return `${String(mins).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
  };

  render() {
    const order = this.getOrderData();

    if (!order || !order.orderId) {
      return (
        <div style={{ textAlign: "center", padding: "30px" }}>
          <img className="logo" src={logo} alt="Logo" />
          <h2>Payment data missing</h2>
          <div>Please go back and choose an amount again.</div>
        </div>
      );
    }

    return (
      <div
        style={{
          padding: "20px",
          textAlign: "center",
          maxWidth: "700px",
          margin: "0 auto",
        }}
      >
        <img className="logo" src={logo} alt="Logo" />

        <h2 style={{ marginTop: "20px" }}>Pay USDT on BNB Chain</h2>

        <div
          style={{
            margin: "20px auto",
            padding: "24px",
            border: "1px solid #ddd",
            borderRadius: "12px",
            background: "#fff",
            maxWidth: "500px",
          }}
        >
          <img
            src={fixedWalletQr}
            alt="Wallet QR"
            style={{ width: "260px", maxWidth: "100%", marginBottom: "20px" }}
          />

          <div style={{ fontSize: "18px", marginBottom: "8px" }}>
            Please send exactly
          </div>

          <div
            style={{
              fontSize: "34px",
              fontWeight: "bold",
              color: "#0a7",
              marginBottom: "18px",
            }}
          >
            {order.exactAmount} USDT
          </div>

          <div style={{ marginBottom: "8px" }}>
            <strong>Wallet address</strong>
          </div>

          <div
            style={{
              background: "#f5f5f5",
              padding: "10px",
              borderRadius: "8px",
              wordBreak: "break-all",
              fontSize: "14px",
              marginBottom: "18px",
            }}
          >
            {order.merchantWallet}
          </div>

          <div style={{ marginBottom: "10px" }}>
            <strong>Order ID:</strong> {order.orderId}
          </div>

          <div style={{ marginBottom: "10px" }}>
            <strong>Expires in:</strong> {this.formatTime(this.state.secondsLeft)}
          </div>

          <div
            style={{
              fontWeight: "bold",
              color: this.state.expired ? "red" : "#0a7",
              marginTop: "10px",
            }}
          >
            {this.state.statusText}
          </div>

          {this.state.error && (
            <div style={{ color: "red", marginTop: "10px" }}>
              {this.state.error}
            </div>
          )}
        </div>

        <div>
          Use the QR code above, enter the exact amount manually in your wallet,
          then complete the transfer.
        </div>

        <br />
        <div>Powered by</div>
        <img className="logo2" src={logo2} alt="Logo 2" />
        <div>New Wave Consulting Group</div>
      </div>
    );
  }
}

export default withRouter(CryptoPay);
